import { render } from "./xlsy.vue?vue&type=template&id=069d994a&scoped=true"
const script = {}

import "./xlsy.vue?vue&type=style&index=0&id=069d994a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069d994a"]])

export default __exports__